import { render, staticRenderFns } from "./ProjectJournalsTTableHeaderRow.vue?vue&type=template&id=2996158f&scoped=true&"
import script from "./ProjectJournalsTTableHeaderRow.vue?vue&type=script&lang=ts&"
export * from "./ProjectJournalsTTableHeaderRow.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectJournalsTTableHeaderRow.vue?vue&type=style&index=0&id=2996158f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996158f",
  null
  
)

export default component.exports